import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';

@Component({
  selector: 'mat-icon-marietti',
  templateUrl: './mat-icon-marietti.component.html',
  styleUrls: ['./mat-icon-marietti.component.css']
})
export class MatIconMariettiComponent implements OnInit {

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon('marietti-logo', sanitizer.bypassSecurityTrustResourceUrl('assets/marietti24.svg'));
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/mat-icon-marietti/mat-icon-marietti.component.ts